const AudienceHome = () => import("../views/pages/tianbao/audienceEn/audience-home.vue");

const tianbaoRouterEn = [
    { // 参展申请 - 登录
        path: '/join-loginEn',
        name: '/join-loginEn',
        component: (resolve) => require(['@views/pages/tianbao/audienceEn/joinExEn/subpages/login'], resolve),
        meta: { requireAuth: false }
    },
    {
        path: "/fillEn",
        name: "fillEn",
        component: AudienceHome,
        redirect: '/fillEn/join/basic',
        meta: { requireAuth: false },
        children: [
            {
                // 参展申请
                path: "join",
                name: "join",
                component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/index"], resolve),
                redirect: "/fillEn/join/basicEn",
                meta: { requireAuth: false },
                children: [
                    {
                        // 基本信息
                        path: "basicEn",
                        name: "basicEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/basic"], resolve),
                        meta: { requireAuth: false }
                    },
                    {
                        // 选择入口
                        path: "entranceEn",
                        name: "entranceEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/entrance"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 选择订单
                        path: "orderEn",
                        name: "orderEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/order"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 会刊信息
                        path: "catalogueEn",
                        name: "catalogueEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/catalogue"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 报名表
                        path: "applicationEn",
                        name: "applicationEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/application"], resolve), meta: { requireAuth: false }
                    },
                    {
                        // 完成
                        path: "finishEn",
                        name: "finishEn",
                        component: resolve => require(["@views/pages/tianbao/audienceEn/joinExEn/subpages/finish"], resolve), meta: { requireAuth: false }
                    },
                ],
            },
        ],
    },
]


export {
    tianbaoRouterEn,
}; 
